import { useAuth0 } from "@auth0/auth0-react";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormContainer } from "components";
import {
    identifiersData,
    inputData,
    permissionsData,
    tracksFormatsFormData,
} from "data";
import { PropTypes } from "prop-types";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useTracksFormatsSchema } from "schemas";
import { StyledTextField } from "styles";
import { canDo, renderFormControllerHandler } from "utils";

const TracksFormatsForm = ({
    action,
    hasDrawer,
    loading,
    onSubmitForm,
    values,
}) => {
    const { t } = useTranslation();

    const { user } = useAuth0();

    const schema = useTracksFormatsSchema();

    const formMethods = useForm({
        defaultValues: values,
        mode: "onChange",
        resolver: yupResolver(schema),
    });

    const {
        control,
        formState: { errors },
    } = formMethods;

    const {
        mediaCreate: mediaCreatePermission,
        mediaRead: mediaReadPermission,
    } = permissionsData.permissions.keys;

    const allowedPermissions = [mediaCreatePermission, mediaReadPermission];

    const {
        text: textInputType,
        textArea: textAreaInputType,
    } = inputData.types;

    const renderFormControllerChildrenHandler = (
        field,
        label,
        name,
        type,
        isOptional,
    ) => {
        switch (type) {
        case textInputType:
        case textAreaInputType:
            return (
                <StyledTextField
                    {...field}
                    error={errors[name]}
                    helperText={errors?.[name]?.message}
                    id={`${name}_${identifiersData.ids.input}`}
                    label={isOptional ? `${t(`labels.${label}`)} (${t("labels.optional")})` : t(`labels.${label}`)}
                    minRows={type === textAreaInputType ? 4 : 1}
                    multiline={type === textAreaInputType}
                    value={field.value || ""}
                    variant="outlined"
                    fullWidth
                />
            );
        }
    };

    return (
        <FormContainer
            action={action}
            formMethods={formMethods}
            loading={loading}
            data={renderFormControllerHandler(
                control,
                tracksFormatsFormData,
                renderFormControllerChildrenHandler,
                hasDrawer,
            )}
            hasSubmitButton={canDo(
                user,
                allowedPermissions,
            )}
            onSubmitForm={onSubmitForm}
        />
    );
};

export default TracksFormatsForm;

TracksFormatsForm.propTypes = {
    action: PropTypes.string,
    hasDrawer: PropTypes.bool,
    loading: PropTypes.bool,
    onSubmitForm: PropTypes.func,
    resetForm: PropTypes.number,
    values: PropTypes.object,
};
